import styles from './DialogFullView.module.css'
import ModalWindow from "../../../../FormTemplate/ModalWindow/ModalWindow";
import {useRef, useState} from "react";
import {ReactZoomPanPinchContentRef, TransformComponent, TransformWrapper} from "react-zoom-pan-pinch";

interface IDialogFullViewProps
{
    img:string
    onClose: ()=>void
}
export default function DialogFullView({onClose,img}:IDialogFullViewProps)
{
    const x = useRef<ReactZoomPanPinchContentRef>(null)
    const [screenHeight] = useState(window.innerHeight-50)

    return (
        <ModalWindow onClose={onClose} >
            <div className={styles.mainCont}>
                <div className={styles.flCont} style={{maxHeight:`${screenHeight}px`}}>
                    <div className={styles.imgCont}>
                        <div className={styles.closeItem} onClick={onClose}>Закрыть</div>
                        <TransformWrapper  ref={x} minScale={0.5} initialScale={1}
                        >
                            <TransformComponent>
                                <img src={img} alt="image" />
                            </TransformComponent>
                        </TransformWrapper>
                    </div>
                </div>

            </div>

        </ModalWindow>
    )


    }